import React from 'react'

export default function ErrorPage() {
    return (
        <div className='ErrorPage'>
            <h1>404</h1>
            <h3>אופס... נראה שהגעת לדף לא נכון!</h3>
        </div>
    )
}